import { useState } from 'react'
import { useVerificationCodeVerify } from 'components/pages/ProfilePage/PhoneForm/types/VerificationCodeVerify'
import ConfirmationCodeField, {
  CODE_LENGTH
} from 'components/ui/ConfirmationCodeField'
import getMutationError from 'utils/getMutationError'

type Props = {
  onSuccess: (phoneToken: string) => void
  phone: string
}

export default function ConfirmationCodeForm({ onSuccess, phone }: Props) {
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | undefined>(undefined)
  const [verifying, setVerifying] = useState(false)
  const [verifyCode] = useVerificationCodeVerify()

  const onVerifyCode = async (value: string) => {
    if (value.length < CODE_LENGTH || verifying) return
    setVerifying(true)
    try {
      const response = await verifyCode({ variables: { code: value, phone } })
      const mutationError = getMutationError(response!)
      if (mutationError) {
        setError(mutationError)
      } else {
        onSuccess(response!.data!.verificationCodeVerify!.phoneToken!)
      }
    } finally {
      setVerifying(false)
    }
  }

  return (
    <ConfirmationCodeField
      className="mb-5"
      description={`Enter the ${CODE_LENGTH}-digit code from SMS`}
      disabled={verifying}
      error={error}
      onChange={(value) => {
        setCode(value)
        setError(undefined)
      }}
      onComplete={onVerifyCode}
      value={code}
    />
  )
}
